module.exports = __webpack_public_path__ + "static/GreatRoom-2a91c8f8794471be71c346efabc574f7.jpg";